var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBigLogo = function SvgBigLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.617 0h-60.52C16.447 0 10.105 5.689 9.574 13.022L.333 140h60.52c7.651 0 13.993-5.689 14.525-13.022L84.617 0Z",
    fill: "#98DAF8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.663 0H61.144C53.493 0 47.151 5.689 46.62 13.022l-6.642 91.363h60.519c7.652 0 13.993-5.689 14.525-13.022L121.663 0Z",
    fill: "#8588C1",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.62 13.022C47.152 5.69 53.5 0 61.145 0H24.097C16.445 0 10.103 5.689 9.572 13.022L.332 140h60.52c7.652 0 13.993-5.689 14.525-13.022l1.641-22.593H39.97l6.65-91.363Z",
    fill: "#02EFF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m84.62 0-7.59 104.385H100.5c7.651 0 13.993-5.689 14.524-13.022L121.668 0H84.619Z",
    fill: "#5E2BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.144 0C53.5 0 47.151 5.689 46.62 13.022l-6.642 91.363h37.048L84.615 0h-23.47Z",
    fill: "url(#bigLogo_svg__a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.617 0h-60.52C16.447 0 10.105 5.689 9.574 13.022L.333 140h60.52c7.651 0 13.993-5.689 14.525-13.022L84.617 0Z",
    fill: "#02EFF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.663 0H61.144C53.493 0 47.151 5.689 46.62 13.022l-6.642 91.363h60.519c7.652 0 13.993-5.689 14.525-13.022L121.663 0Z",
    fill: "#5E2BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.62 13.022C47.152 5.69 53.5 0 61.145 0H24.097C16.445 0 10.103 5.689 9.572 13.022L.332 140h60.52c7.652 0 13.993-5.689 14.525-13.022l1.641-22.593H39.97l6.65-91.363Z",
    fill: "#02EFF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m84.62 0-7.59 104.385H100.5c7.651 0 13.993-5.689 14.524-13.022L121.668 0H84.619Z",
    fill: "#5E2BFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.144 0C53.5 0 47.151 5.689 46.62 13.022l-6.642 91.363h37.048L84.615 0h-23.47Z",
    fill: "url(#bigLogo_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bigLogo_svg__a",
    x1: 89.485,
    y1: 97.467,
    x2: 40.533,
    y2: 9.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02EFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bigLogo_svg__b",
    x1: 89.485,
    y1: 97.467,
    x2: 40.533,
    y2: 9.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02EFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2BFF"
  })))));
};
export default SvgBigLogo;